import { Loader2, MapPinOff } from "lucide-react";
import { LOCATION_REQUIRED_MSG, useCustomerLocation } from "@/context/CustomerLocationContext";

export const LocationRequiredBanner = () => {
  const { status, retry } = useCustomerLocation();
  if (status === "pending") {
    return <p data-testid="location-pending" className="flex items-center gap-2 text-sm text-zinc-400"><Loader2 className="h-4 w-4 animate-spin text-amber-400" /> Getting your location…</p>;
  }
  if (status !== "denied" && status !== "unavailable") return null;
  return (
    <div data-testid="location-required-banner" className="rounded-xl border border-red-500/40 bg-red-500/10 p-4 text-sm">
      <p className="flex items-start gap-2 font-semibold text-red-200"><MapPinOff className="mt-0.5 h-4 w-4 shrink-0" />{LOCATION_REQUIRED_MSG}</p>
      <ul className="mt-3 space-y-1.5 text-xs leading-relaxed text-zinc-300">
        <li><span className="text-amber-200">iPhone (Safari):</span> Settings → Privacy &amp; Security → Location Services → On, then Safari Websites → While Using. In Safari tap “aA” → Website Settings → Location → Allow.</li>
        <li><span className="text-amber-200">Android (Chrome):</span> turn on Location in quick settings, then tap the icon left of the address → Permissions → Location → Allow.</li>
      </ul>
      <button type="button" data-testid="location-retry-button" onClick={retry} className="btn-outline-gold mt-3 !px-4 !py-2 text-xs">I turned it on — try again</button>
    </div>
  );
};

export const useLocationReady = () => useCustomerLocation().status === "on";
